import React from 'react';
import { getFlowNode } from './Flow.ts';
import { useAppState } from './State.tsx';
import ContentOptionStep from './Components/Flow/ContentOptionStep.tsx';
import ChoiceStep from './Components/Flow/Choice.tsx';
import ResultStep from './Components/Flow/Result.tsx';

const StepRouter = () => {
  const { currentNodeId } = useAppState();
  const node = getFlowNode(currentNodeId);

  if (node.kind === 'product') {
    return <ContentOptionStep node={node} />;
  }

  if (node.kind === 'choice') {
    return <ChoiceStep node={node} />;
  }

  return <ResultStep node={node} />;
};

export default StepRouter;
